__turbopack_context__.v({
  "notificationLine": "NotificationsList-module__Sonn_a__notificationLine",
  "notificationLineUnread": "NotificationsList-module__Sonn_a__notificationLineUnread",
  "notificationsList": "NotificationsList-module__Sonn_a__notificationsList",
});
